import { createReducer, on } from "@ngrx/store";
import moment from "moment";
import { AppSettings } from "src/components/shared-components/class/general-classes/app-settings";
import { Gateway } from "src/components/shared-components/class/general-classes/gateway";
import { GatewaySetting } from "src/model/class/general classes/gateway-setting";
import { GenericApiData } from "src/components/shared-components/class/general-classes/generic-api-data";
import { GenericStoreApiData } from "src/components/shared-components/interfaces/generic-store-api-data";
import {
  gateayUpdateFailedBusOperationAction,
  gatewayConnectionStatusChangedAction,
  gatewayLoadErrorAction,
  gatewayLoadSuccessAction,
  gatewayLoadWithOldDataAction,
  gatewayUnsetListAction,
  gatewaySettingsLoadErrorAction,
  gatewaySettingsLoadStartsAction,
  gatewaySettingsLoadWithOldDataAction,
  gatewaySettingsLoadErrorHandlingAction,
  gatewaySettingsLoadSuccessAction,
  gatewaySettingsUnsetListAction
} from "../actions/gateway.actions";
import { MomentFormats } from "src/model/class/general classes/moment-formats";

/**
 * Initial state of gateway store
 */
const initialState: GenericStoreApiData = {
  loaded: false,
  errorGeneric: false,
  errorNotYetImplemented: false,
  isOldDataInUse: false,
  data: null,
};

export const GatewayReducer = createReducer(
  initialState,
  /*
  on(
    gatewayLoadStartsAction, (gatwayObject: GenericStoreApiData, action) => {
      return { ...gatwayObject, loaded: false };
    }),
    */

  on(
    gatewayLoadSuccessAction,
    (gatwayObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: false,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: action.gatwayApiData,
      };
    }),


  on(
    gatewayLoadWithOldDataAction,
    (gatwayObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: false,
        errorNotYetImplemented: false,
        isOldDataInUse: true,
        data: gatwayObject?.data,
      };
    }),


  on(
    gatewayLoadErrorAction,
    (gatwayObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: true,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: null
      }
    }),


  on(gatewayUnsetListAction, (gatwayObject: GenericStoreApiData, action) => {
    return { ...initialState };
  }),
  on(
    gateayUpdateFailedBusOperationAction,
    (gatwayObject: GenericStoreApiData, action) => {

      // const listGateways: Array<Gateway> = gatwayObject.data.data.map(
      const gatewayObjectDataCp = [...(gatwayObject.data?.data || [])];

      const listGateways: Array<Gateway> = gatewayObjectDataCp.map(
        (gateway: Gateway) => {
          if (gateway.instanceGUID === action.instanceGuid) {
            gateway = new Gateway(gateway);
            gateway.failedBusOperationCount = action.failedBusOperationCount;
          }

          return gateway;
        }
      );

      const updateObject: GenericApiData = {
        lastAPIModified: moment().format(
          MomentFormats.MOMENT_DATETIME_FORMAT
        ),
        data: listGateways,
      };

      return { ...gatwayObject, data: updateObject };
    }
  ),
  on(
    gatewayConnectionStatusChangedAction,
    (gatwayObject: GenericStoreApiData, action) => {

      const gatwayObjectDataCp = [...(gatwayObject.data?.data || [])];
      const listGateways: Array<Gateway> = gatwayObjectDataCp.map(
        (gateway: Gateway) => {
          const status = gateway.status;

          if (gateway.instanceGUID === action.instanceGuid) {
            gateway = new Gateway(gateway);
            gateway.status = action.status;
          }

          return gateway;
        }
      );


      const updateObject: GenericApiData = {
        lastAPIModified: moment().format(
          MomentFormats.MOMENT_DATETIME_FORMAT
        ),
        data: listGateways,
      };

      return { ...gatwayObject, data: updateObject };
    }
  )
);

export const GatewaySettingsReducer = createReducer(
  initialState,
  /*
  on(
    gatewayLoadStartsAction, (gatwayObject: GenericStoreApiData, action) => {
      return { ...gatwayObject, loaded: false };
    }),
    */

  on(
    gatewaySettingsLoadSuccessAction,
    (gatwayObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: false,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: action.gatwayApiData,
      };
    }),


  on(
    gatewaySettingsLoadWithOldDataAction,
    (gatwayObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: false,
        errorNotYetImplemented: false,
        isOldDataInUse: true,
        data: gatwayObject?.data,
      };
    }),


  on(
    gatewaySettingsLoadErrorAction,
    (gatwayObject: GenericStoreApiData, action) => {
      return {
        loaded: true,
        errorGeneric: true,
        errorNotYetImplemented: false,
        isOldDataInUse: false,
        data: null
      }
    }),


  on(gatewaySettingsUnsetListAction, (gatwayObject: GenericStoreApiData, action) => {
    return { ...initialState };
  })
);
